import { Component, Vue } from "vue-property-decorator";
import {
  GLOSSARY_ABBREVIATIONS_QUERY,
  GLOSSARY_TERMS_QUERY,
} from "@/graphql/glossary-query";
import { gql } from "graphql-tag";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";

@Component({
  name: "GlossaryComponent",
  components: {
    AppLoaderComponent,
  },
})
export default class GlossaryComponent extends Vue {
  public headerData = [
    { label: "CPRS" },
    { label: "CFSS" },
    { label: "CYAPSS" },
  ];

  public programConfig: any = {
    CPRS: {
      fullName: "Certified Peer Recovery Specialist",
      subtitle:
        "Key terms, abbreviations, and definitions for the Certified Peer Recovery Specialist program in Tennessee.",
      color: "#00A3AF",
    },
    CFSS: {
      fullName: "Certified Family Support Specialist",
      subtitle:
        "Key terms, abbreviations, and definitions for the Certified Family Support Specialist program in Tennessee.",
      color: "#006CB5",
    },
    CYAPSS: {
      fullName: "Certified Young Adult Peer Support Specialist",
      subtitle:
        "Key terms, abbreviations, and definitions for the Certified Young Adult Peer Support Specialist program in Tennessee.",
      color: "#00B478",
    },
  };

  public currentTab = "CPRS";
  public allAbbreviations: any[] = [];
  public allTerms: any[] = [];
  public abbreviations: any[] = [];
  public terms: any[] = [];
  public isLoading = false;

  public get currentProgram() {
    return this.programConfig[this.currentTab];
  }

  public async created() {
    this.isLoading = true;
    try {
      const [abbrevResult, termsResult] = await Promise.all([
        this.$apollo.query({
          query: gql`
            query ${GLOSSARY_ABBREVIATIONS_QUERY}
          `,
        }),
        this.$apollo.query({
          query: gql`
            query ${GLOSSARY_TERMS_QUERY}
          `,
        }),
      ]);
      this.allAbbreviations = abbrevResult.data.glossaryAbbreviations.data;
      this.allTerms = termsResult.data.glossaryTerms.data;
      this.filterData();
    } finally {
      this.isLoading = false;
    }
  }

  public onNavigation(tab: string) {
    this.currentTab = tab;
    this.filterData();
  }

  public filterData() {
    this.abbreviations = this.allAbbreviations
      .filter((item: any) => item.attributes.program === this.currentTab)
      .sort(
        (a: any, b: any) =>
          (a.attributes.seq_id || 0) - (b.attributes.seq_id || 0)
      );
    this.terms = this.allTerms
      .filter((item: any) => item.attributes.program === this.currentTab)
      .sort(
        (a: any, b: any) =>
          (a.attributes.seq_id || 0) - (b.attributes.seq_id || 0)
      );
  }
}
